import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router";
import Header from './Header';
import Footer from './Footer';
import ActiveFilter from './ActiveFilter';
import { Helmet } from "react-helmet";

function Activity() {
const [ActivityData, setActivityData] = useState([]);
const [currency, setCurrency] = useState(localStorage.getItem("currency") || "inr");
const itemsPerPage = 30;
const [currentPage, setCurrentPage] = useState(1);
const [sortOption, setSortOption] = useState("default");
const [paginatedPackages, setPaginatedPackages] = useState([]);
const [selectedLocations, setSelectedLocations] = useState([]);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [filteredPackages, setFilteredPackages] = useState([]);
const [activitydatas, setActivityDatas] = useState(null);

useEffect(() => {
  fetch("https://planjourneysglobal.com/admin/api/home_page/banners/Cruise")
    .then(res => res.json())
    .then(res => setActivityDatas(res.data?.[0] || null))
    .catch(err => console.log(err));
}, []);


useEffect(() => {
  if (selectedLocations.length > 0) {
    setLoading(true);
    setError(null);

    fetch("https://planjourneysglobal.com/admin/api/activities/filter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ locations: selectedLocations }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.data) {
          const filtered = data.data; 
          
          const normalizedFiltered = filtered.map(item => {
            const aedPrice = item.price_aed || item.price || item.package_price;
            return {
              ...item, 
              price_inr: item.price_inr || aedPrice,
              price_usd: item.price_usd || aedPrice,
              price_aed: aedPrice,
            };
          });

          setFilteredPackages(normalizedFiltered);
          setCurrentPage(1); 
        } else {
          setFilteredPackages([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Filter API Error:", err);
        setError("Failed to load filtered data");
        setLoading(false);
      });
  } else {
    setFilteredPackages([]);
    setCurrentPage(1); 
  }
}, [selectedLocations]);

useEffect(() => {
  fetch("https://planjourneysglobal.com/admin/api/cruise_list")
    .then((res) => res.json())
    .then((data) => {
      setActivityData(data?.data || []); 
    })
    .catch((err) => console.log("API Error:", err));
}, []);

const handleSortChange = (e) => {
  setSortOption(e.target.value);
  setCurrentPage(1); 
};

const getPackagesToDisplay = () => {
  return selectedLocations.length > 0 ? filteredPackages : ActivityData;
};


useEffect(() => {
  const packagesToProcess = getPackagesToDisplay();
  let sortedData = [...packagesToProcess];

  switch (sortOption) {
    case "latest":
      sortedData.sort((a, b) => new Date(b.created_at || b.id) - new Date(a.created_at || a.id));
      break;
    case "price_asc":
      sortedData.sort((a, b) => (a.price_inr || 0) - (b.price_inr || 0));
      break;
    case "price_desc":
      sortedData.sort((a, b) => (b.price_inr || 0) - (a.price_inr || 0));
      break;
    default:
      break;
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  setPaginatedPackages(sortedData.slice(startIndex, endIndex));

}, [currentPage, sortOption, filteredPackages, ActivityData]); 


const totalPages = useMemo(() => {
  const packagesToCount = getPackagesToDisplay();
  return Math.ceil(packagesToCount.length / itemsPerPage);
}, [filteredPackages, ActivityData]); 


const handlePageChange = (page) => {
  setCurrentPage(page);
};

useEffect(() => {
  const updateCurrency = () => {
    setCurrency(localStorage.getItem("currency") || "inr");
  };
  window.addEventListener("currency-change", updateCurrency);
  return () => window.removeEventListener("currency-change", updateCurrency);
}, []);

const getPrice = (item) => {
  if (!item) return "";
  if (currency === "usd") return `$${item.price_usd}`;
  if (currency === "aed") return `AED ${item.price_aed}`;
  return `₹${item.price_inr}`;
};




     return (
    <>
     <Helmet>
  <title>{activitydatas?.meta_title}</title>

  <meta
    name="description"
    content={activitydatas?.meta_discription}
  />

  {activitydatas?.meta_keyword && (
    <meta name="keywords" content={activitydatas.meta_keyword} />
  )}

  {/* Canonical */}
  {activitydatas?.slug && (
    <link
      rel="canonical"
      href={`https://planjourneysglobal.com/${activitydatas.slug}`}
    />
  )}

  {/* Open Graph */}
  <meta property="og:title" content={activitydatas?.meta_title} />

  <meta
    property="og:description"
    content={activitydatas?.meta_discription}
  />

  {activitydatas?.image_url && (
    <meta property="og:image" content={activitydatas.image_url} />
  )}

  {activitydatas?.slug && (
    <meta
      property="og:url"
      content={`https://planjourneysglobal.com/${activitydatas.slug}`}
    />
  )}

  <meta property="og:type" content="website" />

  {/* Twitter */}
  <meta name="twitter:title" content={activitydatas?.meta_title} />

  <meta
    name="twitter:description"
    content={activitydatas?.meta_discription}
  />

  {activitydatas?.image_url && (
    <meta name="twitter:image" content={activitydatas.image_url} />
  )}

  <meta name="twitter:card" content="summary_large_image" />
</Helmet>
      <Header />


  {/* Breadcrumb section Start*/}
<div
  className="breadcrumb-section"
  style={{
    backgroundImage: activitydatas?.image_url
      ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.image_url})`
      : "none"
  }}
>
  <div className="container">
    <div className="banner-content">
      <h1>{activitydatas?.banner_name} </h1>
    </div>
  </div>
</div>


{activitydatas?.short_discription?.trim() && (
  <div className="container">
    <div
      className="row justify-content-center mb-0 mt-30 wow animate fadeInDown"
      data-wow-delay="200ms"
      data-wow-duration="1500ms"
    >
      <div className="col-lg-6">
        <div className="section-title text-center">
          <div
            dangerouslySetInnerHTML={{
              __html: activitydatas.short_discription
            }}
          />
        </div>
      </div>
    </div>
  </div>
)}


  {/* Breadcrumb section End*/}
  {/* Experience Grid Page Start*/}
  <div className="package-grid-page pt-100 mb-100">
    <div className="container">
      <div className="row">
        <div className="col-lg-4 d-none">
          <div className="package-sidebar-area">
            <div className="sidebar-wrapper">
              <div className="title-area">
                <h5>Filter</h5>
              </div>
              <div className="single-widgets">
                <div className="widget-title">
                  <h5>Destinations</h5>
                </div>
                <div className="checkbox-container">
                <ActiveFilter  
                                       selectedLocations={selectedLocations}
                                       setSelectedLocations={setSelectedLocations}
                                     />
                </div>
              </div>
        
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="package-grid-top-area mb-50">
         
            <div className="selector-and-list-grid-area">
              <div className="selector-area">
                <span>Sort By:</span>
                <select onChange={handleSortChange} value={sortOption}>
                      <option value="default">Default</option>
                      <option value="latest">Latest</option>
                      <option value="price_desc">Price High</option>
                      <option value="price_asc">Price Low</option>
                    </select>
              </div>
            </div>
          </div>
          <div className="list-grid-product-wrap">

     <div className="row gy-md-4 gy-0">
                  {loading ? (
                    <div className="col-12">
                      <p></p>
                    </div>
                  ) : error ? (
                    <div className="col-12">
                      <p>{error}</p>
                    </div>
                  ) : paginatedPackages.length > 0 ? (
                    paginatedPackages.map((item, index) => (
                      <div
                        key={index}
                        className="col-lg-3 col-md-3 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="package-card">
                          <div className="package-img-wrap">
                            <Link to={`/cruise/${item.slug}`} className="package-img">
                              <img
                                src={`https://planjourneysglobal.com/admin/${item.image}`}
                                alt={item.title}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/assets/img/no-image.png";
                                }}
                              />
                            </Link>

                            {item.is_hot_sale === 1 && (
                              <div className="batch">
                                <span>Hot Sale!</span>
                              </div>
                            )}
                          </div>

                          <div className="package-content">
                            <h5>
                              <Link to={`/cruise/${item.slug}`}>
                                {item.title}
                              </Link>
                            </h5>

                           

                            <div className="btn-and-price-area">
                              <Link to={`/cruise/${item.slug}`} className="primary-btn1">
                                <span>View More </span>
                                <span>View More</span>
                              </Link>

                              <div className="price-area">
                      <span>{getPrice(item)}</span> / <h6>Person</h6>
                  </div>
                            </div>

                            <svg className="divider" height={6} viewBox="0 0 374 6">
                              <path d="M5 2.5L0 0.113249V5.88675L5 3.5V2.5ZM369 3.5L374 5.88675V0.113249L369 2.5V3.5ZM4.5 3.5H369.5V2.5H4.5V3.5Z" />
                            </svg>

                            <div className="bottom-area">
                              <ul>
                                <li>
                                  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.2732 12.9807H6.7268C6.68429 12.9807 6.64298 12.9666 6.60935 12.9406C6.55906 12.9018 5.36398 11.9718 4.14989 10.4857C3.43499 9.61078 2.86499 8.72565 2.45543 7.8549C1.93974 6.75846 1.67834 5.68141 1.67834 4.65329C1.67834 3.50657 2.36043 2.33394 3.54995 1.43595C4.1378 0.992226 4.81163 0.641781 5.55321 0.394396C6.33797 0.132617 7.16112 0 8 0C8.83888 0 9.66203 0.132617 10.4466 0.394396C11.1882 0.641781 11.862 0.992035 12.4499 1.43595C13.6392 2.33394 14.3215 3.50676 14.3215 4.65329C14.3215 5.63247 14.0599 6.67939 13.544 7.7647C13.1348 8.62565 12.5652 9.51367 11.8511 10.4036C10.6383 11.9148 9.40697 12.9272 9.39468 12.9371C9.36046 12.9653 9.31752 12.9807 9.2732 12.9807ZM6.79378 12.5969H9.20334C9.4465 12.3905 10.5082 11.4651 11.5563 10.1576C12.6425 8.8026 13.9374 6.74772 13.9374 4.65329C13.9374 2.63794 11.3981 0.38384 7.99981 0.38384C4.60148 0.38384 2.06238 2.63794 2.06238 4.65329C2.06238 6.85769 3.3563 8.90624 4.44199 10.2364C5.49084 11.5215 6.55311 12.4032 6.79378 12.5969Z"></path>
                                    <path d="M7.51886 12.7888C7.51886 12.7888 5.68372 9.03538 5.68372 4.65327C5.68372 2.43045 6.72066 0.191895 8 0.191895C9.27934 0.191895 10.3163 2.43045 10.3163 4.65327C10.3163 8.82024 8.48114 12.7888 8.48114 12.7888"></path>
                                    <path d="M7.34653 12.873C7.32753 12.8343 6.87594 11.9042 6.41802 10.4209C5.9956 9.05229 5.492 6.94079 5.492 4.65329C5.492 3.53843 5.74668 2.39036 6.19079 1.50312C6.67577 0.533921 7.31832 0 8.00002 0C8.68172 0 9.32426 0.53373 9.80944 1.50312C10.2535 2.39036 10.5082 3.53843 10.5082 4.65329C10.5082 6.82928 10.0048 8.94655 9.5824 10.3393C9.12505 11.8478 8.67423 12.8283 8.65542 12.8692L8.30709 12.7082C8.31169 12.6984 8.7675 11.7058 9.21717 10.2213C9.63114 8.85481 10.1246 6.77977 10.1246 4.65329C10.1246 3.5962 9.88467 2.51051 9.46648 1.67489C9.05577 0.854428 8.52146 0.38384 8.00021 0.38384C7.47895 0.38384 6.94465 0.854428 6.53394 1.67489C6.11574 2.51051 5.87584 3.5962 5.87584 4.65329C5.87584 6.893 6.37023 8.96439 6.78497 10.3076C7.23406 11.7626 7.68699 12.6951 7.6916 12.7043L7.34653 12.873ZM8.77038 16H7.22965C6.84658 16 6.5349 15.6883 6.5349 15.3052V13.9892C6.5349 13.8833 6.62088 13.7973 6.72682 13.7973H9.27321C9.37915 13.7973 9.46513 13.8833 9.46513 13.9892V15.3052C9.46513 15.6883 9.15346 16 8.77038 16ZM6.91874 14.1812V15.3052C6.91874 15.4766 7.05826 15.6162 7.22965 15.6162H8.77038C8.94177 15.6162 9.08129 15.4766 9.08129 15.3052V14.1812H6.91874Z"></path>
                                    <path d="M8.90952 14.1812H7.0907C7.00606 14.1812 6.93159 14.126 6.90703 14.045L6.54334 12.8445C6.52568 12.7863 6.53662 12.7232 6.5729 12.6745C6.60917 12.6257 6.66636 12.5969 6.72701 12.5969H9.2734C9.33424 12.5969 9.39143 12.6257 9.42751 12.6745C9.4454 12.6985 9.45739 12.7264 9.46252 12.756C9.46765 12.7855 9.46579 12.8158 9.45707 12.8445L9.09338 14.045C9.06862 14.1258 8.99397 14.1812 8.90952 14.1812ZM7.23291 13.7974H8.76693L9.01431 12.9808H6.98552L7.23291 13.7974Z"></path>
                                  </svg>
                                  Experience
                                </li>
                                <li>
                                  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                      <path d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z"></path>
                                      <path d="M11.0984 7.32445H8.6197V4.84576C8.6197 4.5037 8.3427 4.22607 8.00001 4.22607C7.65733 4.22607 7.38033 4.5037 7.38033 4.84576V7.32445H4.90164C4.55895 7.32445 4.28195 7.60207 4.28195 7.94414C4.28195 8.2862 4.55895 8.56382 4.90164 8.56382H7.38033V11.0425C7.38033 11.3846 7.65733 11.6622 8.00001 11.6622C8.3427 11.6622 8.6197 11.3846 8.6197 11.0425V8.56382H11.0984C11.4411 8.56382 11.7181 8.2862 11.7181 7.94414C11.7181 7.60207 11.4411 7.32445 11.0984 7.32445Z"></path>
                                    </g>
                                  </svg>
                                  Inclusion
                                  <div className="info">
                                    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                      <g>
                                        <path d="M6 0.375C4.88748 0.375 3.79995 0.704901 2.87492 1.32298C1.94989 1.94107 1.22892 2.81957 0.80318 3.84741C0.377437 4.87524 0.266043 6.00624 0.483085 7.09738C0.700127 8.18853 1.23586 9.19081 2.02253 9.97748C2.8092 10.7641 3.81148 11.2999 4.90262 11.5169C5.99376 11.734 7.12476 11.6226 8.1526 11.1968C9.18043 10.7711 10.0589 10.0501 10.677 9.12508C11.2951 8.20006 11.625 7.11252 11.625 6C11.6245 4.50831 11.0317 3.07786 9.97693 2.02307C8.92215 0.968289 7.49169 0.375497 6 0.375ZM6 9.375C5.85167 9.375 5.70666 9.33101 5.58333 9.2486C5.45999 9.16619 5.36386 9.04906 5.30709 8.91201C5.25033 8.77497 5.23548 8.62417 5.26441 8.47868C5.29335 8.3332 5.36478 8.19956 5.46967 8.09467C5.57456 7.98978 5.7082 7.91835 5.85369 7.88941C5.99917 7.86047 6.14997 7.87533 6.28702 7.93209C6.42406 7.98886 6.54119 8.08499 6.62361 8.20832C6.70602 8.33166 6.75 8.47666 6.75 8.625C6.74941 8.82373 6.6702 9.01415 6.52968 9.15468C6.38915 9.2952 6.19873 9.37441 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.5944 6.71834 6.52472 6.85999 6.41224 6.9632C6.29976 7.0664 6.15266 7.12367 6 7.12367C5.84735 7.12367 5.70024 7.0664 5.58776 6.9632C5.47528 6.85999 5.40561 6.71834 5.3925 6.56625L5.14125 3.55875C5.13042 3.44226 5.1434 3.32478 5.1794 3.21346C5.2154 3.10214 5.27367 2.99931 5.35067 2.91123C5.42767 2.82314 5.52178 2.75165 5.62729 2.70108C5.73279 2.65052 5.84748 2.62195 5.96437 2.61711C6.08127 2.61227 6.19793 2.63126 6.30725 2.67294C6.41657 2.71461 6.51627 2.77808 6.60029 2.8595C6.6843 2.94092 6.75087 3.03858 6.79595 3.14655C6.84103 3.25451 6.86367 3.37051 6.8625 3.4875C6.86313 3.51131 6.86187 3.53514 6.85875 3.55875Z"></path>
                                      </g>
                                    </svg>
                                    <div className="tooltip-text">This package covers <span>Accommodation, Daily Meals, Entry Fees &amp; Local Transfers</span> to ensure a worry-free trip.</div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12">
                      <p></p>
                    </div>
                  )}
                </div>




          </div>
        {/* Pagination Controls */}
                     {/* Pagination Controls */}
                                                 {totalPages > 1 && (
                      <div
                        className="pagination-area mt-60 wow animate fadeInUp"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="paginations-button">
                          <Link
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Prev <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><g><path d="M7.86133 9.28516C7.14704 7.49944 3.57561 5.71373 1.43276 4.99944C3.57561 4.28516 6.7899 3.21373 7.86133 0.713728" stroke-width="1.5" stroke-linecap="round"></path></g></svg>
                          </Link>
                        </div>
                    
                        <ul className="paginations">
                          <li className="page-item active">
                            <a href="#">{currentPage}</a>
                          </li>
                        </ul>
                    
                        of {totalPages}
                    
                        <div className="paginations-button">
                          <Link
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><g><path d="M1.42969 9.28613C2.14397 7.50042 5.7154 5.7147 7.85826 5.00042C5.7154 4.28613 2.50112 3.21471 1.42969 0.714705" stroke-width="1.5" stroke-linecap="round"></path></g></svg>
                          </Link>
                        </div>
                      </div>
                    )}
        </div>
      </div>
    </div>
  </div>
  {/* Experience Grid Page End*/}

         <Footer />
    </>
  );
}

export default Activity;
